import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Invoice } from '../models/invoice.entity'

export type InvoiceNotificationCode =
  | GenericNotificationCode
  | 'INVOICE_DELETED'
  | 'INVOICE_SAVED'

export type InvoiceModalCode = 'INVOICE_DELETION'

/**
 * Parse goods return code to a notification
 * @param code - the goods return notification code
 * @returns the notification options
 */
export function parseInvoiceNotification(
  code?: InvoiceNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'INVOICE_DELETED':
      return {
        message: 'Invoice deleted successfully',
        color: 'success',
      }
    case 'INVOICE_SAVED':
      return {
        message: 'Invoice saved successfully',
        color: 'success',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse goods return code to an modal
 * @param code - the goods return modal code
 * @param goodsReturn - the goods return object
 * @returns the modal settings
 */
export function parseInvoiceModal(
  code: InvoiceModalCode,
  invoice?: Invoice,
): DialogOptions {
  switch (code) {
    case 'INVOICE_DELETION': {
      return {
        title: 'Delete invoice',
        message:
          'Are you sure you want to delete the invoice <strong>%s</strong>?',
        messageParams: invoice?.header.invoiceNumber
          ? [invoice.header.invoiceNumber]
          : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
